import { render, staticRenderFns } from "./officeDetail.vue?vue&type=template&id=b711786a&"
import script from "./officeDetail.vue?vue&type=script&lang=js&"
export * from "./officeDetail.vue?vue&type=script&lang=js&"
import style0 from "./officeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports